<template>
  <div>
    <b-table sort-icon-left :items="user_projects" :fields="userfields" @row-clicked="onProjectClicked" :tbody-tr-attr="rowClass">
      <template #cell(pulldown)="row">
        <b-dropdown id="dropdown-dropup" dropup :text="$t('buttons.doaction')" variant="primary">
          <b-dropdown-item @click="generate_urenbonpdf(row.item.contract_id)"> <font-awesome-icon icon="hourglass-half" /> {{ $t("labels.showurenbon") }} </b-dropdown-item>
          <b-dropdown-item @click="clone_contract(row.item)"> <font-awesome-icon icon="clone" /> {{ $t("labels.duplicateopdracht") }} </b-dropdown-item>
          <b-dropdown-item @click="delete_user_project(row.item)" :title="$t('labels.deleteuser')"> <font-awesome-icon icon="trash" /> {{ $t("labels.deletecontract") }} </b-dropdown-item>
          <b-dropdown-item @click="generate_company_pdf(row.item.contract_id)"> <font-awesome-icon icon="file-pdf" /> {{ $t("labels.showcontractcompany") }} </b-dropdown-item>
          <b-dropdown-item @click="generate_pdf(row.item)"> <font-awesome-icon icon="file-pdf" /> {{ $t("labels.showcontract") }} </b-dropdown-item>

          <b-dropdown-item @click="sendConfirmModal(row.item.contract_id)"> <font-awesome-icon icon="envelope-open" /> {{ $t("buttons.sendconfirm") }} </b-dropdown-item>
          <b-dropdown-item @click="sendContractModal(row.item.contract_id)"> <font-awesome-icon icon="envelope-open" /> {{ $t("buttons.sendcontract") }} </b-dropdown-item>

          <b-dropdown-item @click="sendReviewModal(row.item.contract_id)"> <font-awesome-icon icon="envelope-open" /> {{ $t("buttons.addreview") }} </b-dropdown-item>

          <b-dropdown-item @click="editContractModal(row.item.project_id, row.item.zzpr)"> <font-awesome-icon icon="cog" /> {{ $t("labels.editcontract") }} </b-dropdown-item>
          <b-dropdown-item @click="showUserHours(row.item.contract_id)"> <font-awesome-icon icon="clipboard-list" /> {{ $t("labels.showhours") }} </b-dropdown-item>
        </b-dropdown>
        <span v-if="current_user.id == 1">{{ row.item.contract_id }}</span>
      </template>
      <template #cell(company_id)="row">
        <a href="javascript:;" @click="companyto(row.value)">{{ companyname_by_id(row.value) }}</a>
      </template>
      <template #cell(zzpr)="row">
        <img class="profile-photo" :src="profileto(row.item.zzpr)" />
      </template>
      <template #cell(zzprname)="row">
        {{ username_by_id(row.item.zzpr) }}
      </template>
      <template #cell(signid)="row">
        {{ username_by_id(row.item.signid) }}
      </template>
      <template #cell(zzprmobile)="row">
        <a :href="phoneto(row.value)">{{ phoneformat(row.value) }}</a>
      </template>
    </b-table>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import popup_modal from "../modals/PopupModal.vue";
import axios from "axios";

export default {
  name: "admin-project-overview",
  data() {
    return {
      selected_contractID: null,
      selected_week: -1,
      selected_year: 2024,
    };
  },
  props: {
    user_id: Number,
    show_archive: String,
  },

  computed: {
    user: {
      get() {
        return this.user_id ? this.user_by_id(this.user_id) : null;
      },
    },
    userfields() {
      return [
        { key: "pulldown", label: this.$i18n.t("labels.actions") },
        { key: "startdate", label: this.$i18n.t("labels.startdate"), sortable: true, sortDirection: "desc" },
        { key: "enddate", label: this.$i18n.t("labels.enddate"), sortable: true, sortDirection: "desc" },
        { key: "zzpr", label: this.$i18n.t("labels.photo") },
        { key: "zzprname", label: this.$i18n.t("labels.name") },
        { key: "zzprmobile", label: this.$i18n.t("meta.mobiel") },
        { key: "company_id", label: this.$i18n.t("labels.bycompany"), sortable: true, sortDirection: "desc" },
        // { key: 'signid', label:this.$i18n.t('labels.authorizedsignatory')},
        // { key: 'signmobile',label: this.$i18n.t('meta.mobiel')},
        { key: "title", label: this.$i18n.t("labels.project"), sortable: true, sortDirection: "desc" },
        { key: "location", label: this.$i18n.t("labels.location"), sortable: true, sortDirection: "desc" },
      ];
    },
    user_projects() {
      let myprojects = [];
      var now = new Date();
      if (this.user.role == "user") {
        this.planning
          .filter((plan) => plan.user_id == this.user_id)
          .forEach((plan) => {
            // console.log(">>",plan)
            // console.log(">>",this.contracts.filter(c=>c.planning_id==plan.id))
            if (this.contracts.filter((c) => c.planning_id == plan.id).length > 0) {
              let row = {};
              row.id = plan.project_id;
              row.project_id = plan.project_id;
              row.company_id = this.project_by_id(plan.project_id) && this.project_by_id(plan.project_id).company_id ? this.project_by_id(plan.project_id).company_id : null;
              row.planning_id = plan.id;
              if (this.contracts.filter((c) => c.planning_id == plan.id).length > 0) {
                row.contract_id = this.contracts.filter((c) => c.planning_id == plan.id)[0].id;
                row.color = this.contract_by_id(row.contract_id).color != undefined ? this.contract_by_id(row.contract_id).color : "#eeeeee";
              }

              row.title = plan.project_name;
              row.sortdate = plan.startdate;
              row.startdate = this.formatDate(plan.startdate);
              row.enddate = this.formatDate(plan.enddate);
              row.location = plan.project_location;
              row.zzpr = this.user.id;
              row.zzprname = this.user.id;
              row.zzprmobile = this.user_by_id(this.user.id).mobile;
              row.signid = plan.sign_id;
              row.signmobile = this.user_by_id(plan.sign_id) && this.user_by_id(plan.sign_id).mobile ? this.user_by_id(plan.sign_id).mobile : "";
              if (now < this.plus1week(plan.enddate) || this.show_archive != "0") {
                myprojects.push(row);
              }
            }
          });
      } else {
        //signer
        this.planning
          .filter((plan) => plan.sign_id == this.user_id)
          .forEach((plan) => {
            let row = {};
            row.id = plan.project_id;
            row.project_id = plan.project_id;
            row.company_id = this.project_by_id(plan.project_id).company_id;
            row.planning_id = plan.id;
            row.contract_id = this.contracts.filter((c) => c.planning_id == plan.id)[0].id;
            row.color = this.contract_by_id(row.contract_id).color != undefined ? this.contract_by_id(row.contract_id).color : "#eeeeee";

            row.title = plan.project_name;
            row.sortdate = plan.startdate;
            row.startdate = this.formatDate(plan.startdate);
            row.enddate = this.formatDate(plan.enddate);
            row.location = plan.project_location;
            row.zzpr = plan.user_id;
            row.zzprname = plan.user_id;
            row.zzprmobile = this.user_by_id(this.user.id).mobile;
            row.signid = plan.sign_id;
            row.signmobile = this.user_by_id(plan.sign_id).mobile;
            if (now < this.plus1week(plan.enddate) || this.show_archive != "0") {
              myprojects.push(row);
            }
          });
      }
      return this.sortprojects(myprojects);
    },
    thisweek() {
      return parseInt(this.getWeekNumber(new Date())[1]);
    },

    ...mapGetters(["user_metas", "user_by_id", "activebranches", "user_new", "branche_by_id", "createAny", "planning_by_id", "contract_by_id", "project_by_id", "username_by_id", "find_planning", "find_contract_id", "user_photo_by_id", "server_url", "append_data_string", "confirm_modal", "company_by_id", "find_last_planning_user", "companyname_by_id"]),
    ...mapState(["users", "current_user", "branches", "workfields", "avatars", "projects", "contracts", "hours", "companies", "planning"]),
  },
  methods: {
    companyto(id) {
      this.$router.push({ path: "/company/" + id });
    },

    onProjectClicked(row) {
      if (this.createAny("users")) {
        this.$router.push({ path: "/project/" + row.id });
      }
    },
    rowClass(item) {
      return { style: "background-color:" + item.color };
    },

    usershours(contract_id, user_id) {
      return this.hours
        .filter((obj) => {
          return obj.user_id === user_id;
        })
        .filter((obj2) => {
          return obj2.contract_id === contract_id;
        });
    },
    sortprojects(myprojects) {
      let a = myprojects.sort((a, b) => (a.sortdate > b.sortdate ? -1 : b.sortdate > a.sortdate ? 1 : 0));
      return a;
    },
    ...mapActions(["save_user", "add_user", "save_contract"]),
    has_hours(contract_id) {
      // let daysFilled = 0;
      // for (var i = 0; i < this.hours.length; i++) {
      //   if (this.hours[i].contract_id == contract_id) {
      //     daysFilled++
      //   }
      // }
      return this.hours.filter((h) => h.contract_id == contract_id).length;
      // return daysFilled;
    },

    sign_by_zzpr(contract) {
      this.contract_by_id(contract.id).signed_zzpr = 1;
      this.save_contract(contract.id);
    },

    async delete_user_project(id) {
      // console.log(id)
      // let obj = {}
      //             obj.user_id = id.zzpr
      //             obj.signer_id = id.signid
      //             obj.contract_id = id.contract_id
      //             await axios.post('/api/get_review_user_hash/', obj)  .then( async (response) => {
      //               console.log('succes',response)
      //             })

      this.selectedID = id.project_id;
      let message = this.$i18n.t("labels.confirmdeletehead") + id.title + " " + this.$i18n.t("labels.confirmdeletetail");
      let alert = "";

      if (this.hours.filter((h) => h.contract_id == id.contract_id).length > 0) {
        alert += this.$i18n.t("validation.contracthashours");
      }
      this.$modal.hide("popup_modal");
      this.$modal.show(
        popup_modal,
        {
          message: message,
          alert: alert,
        },
        {
          name: "popup_modal",
          draggable: false,
          height: "auto",
          width: "500px",
        },
        {
          "before-close": this.modalCloseDeleteUserProject,
        }
      );

      this.$emit("close");
    },
    modalCloseDeleteUserProject() {
      if (this.confirm_modal.id == 1) {
        let project_id = this.selectedID;
        var datatosend = { project_id: project_id, user_id: this.user.id };
        this.$store.dispatch("remove_project_relations", datatosend);
        let project = this.project_by_id(project_id);
        project.zzprusers.splice(project.zzprusers.indexOf(this.user.id), 1);
        let spliceplanning = -1;
        for (var i = 0; i < this.planning.length; i++) {
          if (this.planning[i].user_id == this.user.id && this.planning[i].project_id == project_id) {
            spliceplanning = i;
            this.$store.dispatch("delete_planning", this.planning[i].id);
            break;
          }
        }
        if (spliceplanning != -1) {
          this.planning.splice(spliceplanning, 1);
        }
      }
    },
    async clone_contract(item) {
      // console.log(item)
      let contract = this.contract_by_id(item.contract_id);
      // first clone project
      let project_clone = Object.assign({}, this.project_by_id(this.planning_by_id(item.planning_id).project_id));
      if (project_clone.id == project_clone.project_reference_number) project_clone.project_reference_number = "";
      project_clone.id = 0;
      project_clone.title = "(COPY) " + project_clone.title;
      project_clone.is_public = 0;
      project_clone.projectnumber = "";

      console.log("step 1", project_clone);
      await axios.put("/api/project/" + project_clone.id, project_clone).then(async (response) => {
        let project_id = response.data.id;
        //add user to project
        var datatosend = { project_id: project_id, user_id: item.zzpr };
        this.$store.dispatch("save_project_relations", datatosend);
        console.log("step 2", datatosend);

        //create contract
        let clone = Object.assign({}, this.planning_by_id(item.planning_id));
        clone.id = 0;
        clone.project_name = "(COPY) " + clone.project_name;
        clone.contract_id = 0;
        clone.project_id = project_id;
        clone.registerdeclarations = contract.registerdeclarations;
        ///call axois
        console.log("step 3", datatosend);
        await axios.put("/api/planning/" + clone.id, clone).then(async (response) => {
          let last_contract_id = response.data.contract_id;
          clone.id = response.data.id;
          console.log("step 4", clone);
          // console.log("step 4",contract)
          let colorset = {};
          colorset.id = last_contract_id;
          colorset.color = contract.color;
          console.log("step 5", colorset);

          await axios.post("/api/set_contract_color/", colorset);
          let count = 0;
          if (contract.onregelmatig.length > 0) {
            for (const decla of contract.onregelmatig) {
              console.log("onregelmatig", decla);
              decla.contract_id = last_contract_id;
              decla.zzper = decla.zzpr_amount;
              decla.client = decla.client_amount;
              await axios.put("/api/onregelmatig/", decla).then(() => {
                count++;
                if (count == contract.onregelmatig.length) {
                  this.$store.dispatch("get_planning");
                  this.$store.dispatch("get_contracts");
                  this.$store.dispatch("get_projects");
                }
              });
            }
          } else {
            this.$store.dispatch("get_planning");
            this.$store.dispatch("get_contracts");
            this.$store.dispatch("get_projects");
          }
        });
      });
    },
  },
  components: {},
};
</script>
